import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=204ec964&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=ts"
export * from "./NotificationCard.vue?vue&type=script&lang=ts"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=204ec964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ec964",
  null
  
)

export default component.exports